import React from "react";
import { Gem, CircleDashed, Sparkles, Diamond, Heart } from "lucide-react";

// Fixed positions/sizes/delays (not randomized) so the layout is stable
// across re-renders and identical on server vs. client.
const ICONS = [
  { Icon: Gem, top: "8%", left: "6%", size: 28, delay: "0s", duration: "6s", opacity: 0.10 },
  { Icon: CircleDashed, top: "18%", left: "88%", size: 34, delay: "1.2s", duration: "7s", opacity: 0.08 },
  { Icon: Sparkles, top: "62%", left: "4%", size: 22, delay: "0.6s", duration: "5.5s", opacity: 0.12 },
  { Icon: Diamond, top: "75%", left: "92%", size: 26, delay: "2s", duration: "6.5s", opacity: 0.09 },
  { Icon: Heart, top: "40%", left: "95%", size: 20, delay: "1.6s", duration: "5s", opacity: 0.08 },
  { Icon: CircleDashed, top: "85%", left: "15%", size: 18, delay: "0.3s", duration: "6s", opacity: 0.07 },
  { Icon: Gem, top: "30%", left: "2%", size: 20, delay: "2.4s", duration: "7s", opacity: 0.07 },
];

/**
 * Purely decorative, low-opacity floating jewelry icons (rings, gems,
 * sparkles) drifting slowly in the background of a section. Non-
 * interactive and hidden from screen readers — visual flavor only, meant
 * to make key sections feel a little more alive without being distracting.
 */
export const FloatingJewelry = ({ className = "" }) => (
  <div className={`absolute inset-0 overflow-hidden pointer-events-none select-none ${className}`} aria-hidden="true">
    {ICONS.map(({ Icon, top, left, size, delay, duration, opacity }, i) => (
      <Icon
        key={i}
        className="absolute text-primary animate-float"
        style={{
          top,
          left,
          width: size,
          height: size,
          opacity,
          animationDelay: delay,
          animationDuration: duration,
        }}
      />
    ))}
  </div>
);
